import React from 'react'
import BirthCertAttestationFaMain from './BirthCertAttestationFaMain'
import FaqHead from '../../../HomePage/Faq/FaqHead'

const BirthCertAttestationFaq = () => {
  return (
 <div className="faqContainer">
      <div className="faqContent">
        <FaqHead heading="Degree Certificate Attestation in Bangalore" />
        <BirthCertAttestationFaMain />
      </div>
    </div>
  )
}

export default BirthCertAttestationFaq
